import { render, staticRenderFns } from "./BookingGoodsDetails.vue?vue&type=template&id=6e735c47&scoped=true"
import script from "./BookingGoodsDetails.vue?vue&type=script&lang=js"
export * from "./BookingGoodsDetails.vue?vue&type=script&lang=js"
import style0 from "./BookingGoodsDetails.vue?vue&type=style&index=0&id=6e735c47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e735c47",
  null
  
)

export default component.exports